<template>
  <v-tooltip v-if="proxyCount" bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon>
        <v-badge :content="proxyCount" :overlap="true">
          <v-icon color="primary" v-bind="attrs" v-on="on"
            >mdi-account-multiple</v-icon
          >
        </v-badge>
      </v-btn>
    </template>
    <span>You are a proxy bidder for {{ proxyCount }} others</span>
  </v-tooltip>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      title: process.env.VUE_APP_TITLE,
      showProxies: false
    };
  },
  computed: {
    proxyCount() {
      let count = 0;
      if (this.proxies) {
        count += this.proxies.length;
      }
      if (this.user.weightedProxy > 0) {
        count += this.user.weightedProxy;
      }
      return count;
    },
    ...mapState({
      user: (state) => state.user,
      proxies: (state) => state.proxies,
      event: (state) => state.event
    })
  }
};
</script>
